export default {
      id: "map-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#map-usage",
      toString: function () {
        return this.url;
      }
    }